<template>
  <div
    style="background-color: lightgray"
    class="container"
    :class="{ 'is-mobile': isMobile }"
  >
    <div class="header-title" style="z-index: 999999; background: transparent;position:absolute;width: 32px;height: 32px;" >
      <span
        style="position: absolute; left: 2.2rem; top: 1.5rem;"
        @click.stop="backUp"
        @mousedown.stop
        @mouseup.stop
        ><van-icon name="revoke"></van-icon
      ></span>
    </div>
    <!-- 智能客服聊天组件 -->
    <iframe src="/chatmsg.html" ref="iframeref"> </iframe>
    <!-- 底部输入框占位 -->
    <div class="chat-input-area"></div>
    <!--自定义消息部件-->
    
    <!--自定义部件end-->
  </div>
</template>

<script>
import emojiList from "../../lib/emoji.js";
import { socketServer } from "../../mixins/socketServer.js";

export default {
  // mixins: [socketServer],
  data() {
    return {
      isLoad: false,
      emojiList: emojiList,
      inputConType: 1,
      avatar_img: require("@/assets/img/avtor.png"),
      deviceType: "pc",
    };
  },
  computed: {
    // records() {
    //   try {
    //     return this.chatServerData.serviceList.map((item, index) => {
    //       const newItem = { ...item };
    //       newItem.time = this.formatTime(item.add_time);
    //       if (index) {
    //         const prev = this.chatServerData.serviceList[index - 1];
    //         newItem.show = (item.add_time - prev.add_time) >= 300;
    //       } else {
    //         newItem.show = true;
    //       }
    //       return newItem;
    //     });
    //   } catch (e) {
    //     console.error("records computed error:", e);
    //     return [];
    //   }
    // },
  },
  mounted() {
    // 客服页不是 tab 主页面，通知 Home 布局隐藏底部 tabbar（与其它子页面一致）
    this.$emit("titleChange", "客服");
  },
  methods: {
    backUp(event) {
      // 使用 router.back() 返回上一页。redirect() 已改用 replace 不会污染历史记录
      // 阻止所有事件传递
      event.stopPropagation();
      event.preventDefault();
      this.$router.replace("/home/uservipcenter#/");
    },
    formatTime(timestamp) {
      if (!timestamp) return "";
      const d = new Date(timestamp * 1000);
      const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
      const month = months[d.getMonth()];
      const day = d.getDate();
      const suffix = day === 1 || day === 21 || day === 31 ? "st"
        : day === 2 || day === 22 ? "nd"
        : day === 3 || day === 23 ? "rd" : "th";
      const hours = String(d.getHours()).padStart(2, "0");
      const mins = String(d.getMinutes()).padStart(2, "0");
      return `${month} ${day}${suffix} ${hours}:${mins}`;
    },
    tolink() {
      // 预留：点击版权链接
    },
    getScrollTop() {
      console.log(123);
    },
    getScrollEnd() {
      console.log(321);
    },
    onScroll() {
      const el = this.$refs.chatScrollBox;
      if (el && el.scrollTop === 0) {
        // 滑动到顶部触发加载更多
        this.isLoad = true;
        // 调用 mixin 中的 scrollHandler（如果有的话）
        setTimeout(() => {
          this.isLoad = false;
        }, 2000);
      }
    },
    imageLoad() {
      // 图片加载成功后，触发滚动到底部
      this.goPageBottom();
    },
    imageError(item, e) {
      // 图片加载失败时显示占位图，避免显示空白
      console.warn("图片加载失败:", item.msn);
      e.target.src = require("@/assets/img/picture.png");
    },
    // 聊天表情转换
    replace_em(str) {
      str = str.replace(/\[em-([\s\S]*)\]/g, "<span class='em em-$1'/></span>");
      return str;
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100vh;
  height: 100dvh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* 智能客服 iframe 撑满除底部输入框外的剩余空间 */
iframe {
  display: block;
  flex: 1;
  min-height: 0;
  width: 100%;
  border: none;
}

/* 底部输入框占位 */
.chat-input-area {
  flex-shrink: 0;
  height: 0px;
  padding-bottom: env(safe-area-inset-bottom, 0px);
  background: #fff;
}

.max-width_con {
  max-width: 600px;
}

.max-width_advertisement {
  max-width: 840px;
}

.pc_customerServer_container {
  width: 100%;
  height: 80dvh;
  // max-height: 654px;
  margin-top: 10dvh;
  display: flex;
  flex-direction: column;
  background: #fff;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 1px 1px 15px 0px rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  overflow: hidden;

  &_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: linear-gradient(270deg, #1890ff, #3875ea);
    padding: 14px 14px;
    box-sizing: border-box;
    height: 56px;
    font-size: 16px;
    color: #fff;

    &_title {
      display: flex;
      align-items: center;

      img {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        margin-right: 10px;
      }
    }

    &_handle {
      cursor: pointer;
    }
  }

  &_content {
    flex: 1;
    min-height: 0;
    overflow: hidden;

    .scroll_content {
      width: 100%;
      height: 100%;
      overflow-y: auto;
      padding-bottom: 20px;
      box-sizing: border-box;
      position: relative;

      .chart_list {
        &_item {
          &_content {
            display: flex;
            align-items: center;
            padding: 8px;
            box-sizing: border-box;
          }

          &_avatar {
            width: 33px;
            height: 33px;
            border-radius: 50%;
            overflow: hidden;
            margin-right: 10px;
            align-self: flex-start;

            img {
              width: 100%;
              height: 100%;
            }
          }

          &_text {
            max-width: 60%;
            word-wrap: break-word;
            background: #f5f5f5;
            padding: 7px 14px;
            font-size: 15px;
            border-radius: 4px;
          }

          &_img {
            max-width: 60%;

            img {
              width: 100%;
              height: auto;
            }
          }

          .chart_list_item_imgOrText {
            background: #ccc;
            padding: 4px 10px;
            border-radius: 8px;
            width: 226px;
            box-sizing: border-box;

            .order-wrapper {
              .img-box {
                width: 100%;

                img {
                  width: 100%;
                  height: auto;
                }
              }

              .order-info {
                .price-box {
                  color: #ff0000;
                  font-size: 18px;
                }

                .name {
                  font-size: 14px;
                }
              }
            }
          }

          &_time {
            text-align: center;
            margin: 10px auto;
          }

          .right-box {
            flex-direction: row-reverse;

            .chart_list_item_avatar {
              margin-left: 10px;
            }

            .chart_list_item_text {
              text-align: left;
              background: #cde0ff;
              color: #000000;
            }

            .chart_list_item_img {
              text-align: right;
              background: #fff;

              img {
                width: 100%;
                height: auto;
              }
            }

            .chart_list_item_imgOrText {
              background: #fff;
              padding: 10px;
              border-radius: 8px;
              width: 226px;
              box-sizing: border-box;

              .order-wrapper {
                .img-box {
                  width: 100%;

                  img {
                    width: 100%;
                    height: auto;
                  }
                }

                .order-info {
                  .price-box {
                    color: #ff0000;
                    font-size: 18px;
                  }

                  .name {
                    font-size: 14px;
                  }
                }
              }
            }
          }

          // 移除空的 &_text 块
        }
      }
    }
  }

  &_footer {
    flex-shrink: 0;
    background: #fff;
    padding: 14px 18px;
    min-height: 180px;
    border-top: 1px solid #ececec;

    &_header {
      position: relative;

      &_handle {
        display: flex;

        > div {
          margin-right: 19px;
          position: relative;

          img {
            width: 18px;
            height: 18px;
          }

          .type_file {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            opacity: 0;
          }
        }
      }
    }

    &_input {
      &-textarea {
        width: 100%;
        height: 100%;
        border: none;
        outline: none;
        padding-top: 4px;
        font-size: 14px;
        line-height: 16px;
      }

      > div {
        height: 90px;
        max-height: 90px;
        overflow: auto;
      }

      .opacity0 {
        opacity: 0;
      }

      .readyEmojiHeight {
        height: 90px;
      }
    }

    &_emoji {
      max-width: 420px;
      display: grid;
      grid-template-columns: repeat(9, 1fr);
      padding-top: 10px;
      max-height: 150px;
      overflow-y: auto;
      background: #fff;
      position: absolute;
      bottom: 50px;
      left: 0;

      .emoji-item {
        padding: 6px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    &_handle {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-bottom: 10px;

      &_send {
        width: 56px;
        height: 26px;
        background: #3875ea;
        border-radius: 3px;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        position: relative;
        z-index: 100;
        margin: 0 20px 20px 0;
      }
    }

    &_copyright {
      position: absolute;
      left: -8%;
      width: 110%;
      display: block;
      text-align: center;
      bottom: 0;
      color: #bbb;
      padding: 5px 10px;
      /*background-color: #eee;*/
    }
  }
}

.layout_content {
  flex: 1;
  display: flex;
  min-height: 0;
  // justify-content: space-between;
  .layout_customerServer_content {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
    border-right: 1px solid #ececec;
  }

  .pc_customerServer_container_advertisement {
    width: 260px;
    background: #fff;

    .advertisement {
      padding: 5px;
      box-sizing: border-box;
      height: 550px;
      overflow-y: auto;

      img {
        max-width: 100% !important;
      }
    }

    .copyright {
      position: fixed;
      bottom: 20px;
      text-align: center;
      width: 230px;
      transition: 0.3s;
      z-index: 99;
      cursor: pointer;

      span {
        color: #ccc;
      }

      span:hover {
        color: #007aff;
      }
    }
  }
}

.loading-spin {
  text-align: center;
  padding: 12px 0;
  color: #999;
  font-size: 12px;
}
.loading-spin .van-loading {
  display: block;
  margin: 0 auto 6px;
}

.productMessage_container {
  height: 94px;
  width: 100%;
  padding: 12px;
  box-sizing: border-box;
  background: #fff;
  display: flex;
  justify-content: space-between;

  &_image {
    margin-right: 12px;

    img {
      width: 77px;
      height: 77px;
    }
  }

  &_content {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    &_title {
      font-size: 14px;
      color: #333;
      height: 42px;
      font-weight: 800;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      text-align: left !important;
    }

    &_priceOrHandle {
      display: flex;
      justify-content: space-between;

      > div:nth-child(1) {
        font-size: 18px;
        color: #e93323;
        text-align: left;
      }

      > div:nth-child(2) {
        width: 65px;
        height: 25px;
        background: #e83323;
        opacity: 1;
        border-radius: 62px;
        color: #fff;
        font-size: 12px;
        text-align: center;
        line-height: 25px;
        cursor: pointer;
      }
    }
  }
}

.fixed {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
}

.pt140 {
  padding-bottom: 140px !important;
}

@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(180deg);
  }

  to {
    transform: rotate(360deg);
  }
}

// 将 /deep/ 替换为 :deep()
// 第二个 style 标签的内容
.advertisement {
  img,
  p,
  div,
  span {
    max-width: 100%;
  }
}

.advertisement {
  overflow: auto !important;
}

.advertisement::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 1px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}

.advertisement::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background-color: skyblue;
  background-image: -webkit-linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.2) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.2) 50%,
    rgba(255, 255, 255, 0.2) 75%,
    transparent 75%,
    transparent
  );
}

.advertisement::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #ededed;
  border-radius: 10px;
}

/* ========== 移动端适配 ========== */
@media (max-width: 768px) {
  .container.is-mobile {
    padding: 0;
    margin: 0;
  }

  /* 头部 — 安全区域适配 */
  .pc_customerServer_container_header {
    flex-shrink: 0;
    padding-top: env(safe-area-inset-top, 0px);
    height: 54px;
  }

  .pc_customerServer_container_header_handle {
    padding: 12px;
    font-size: 20px;
  }

  /* 移动端隐藏广告栏 */
  .pc_customerServer_container_advertisement {
    display: none !important;
  }

  /* 聊天消息适配 */
  .chart_list_item_text {
    max-width: 75% !important;
    font-size: 14px !important;
  }

  .chart_list_item_imgOrText {
    width: 200px !important;
  }

  /* 表情面板 — 减少列数 */
  .pc_customerServer_container_footer_emoji {
    grid-template-columns: repeat(6, 1fr) !important;
    max-width: 100% !important;
    bottom: 60px !important;
    z-index: 200;
  }

  /* 输入区域 */
  .pc_customerServer_container_footer {
    flex-shrink: 0;
    min-height: auto;
    padding: 8px 12px;
    padding-bottom: calc(12px + env(safe-area-inset-bottom, 0px));
    border-top: 1px solid #ececec;
  }

  .pc_customerServer_container_footer_header_handle > div {
    margin-right: 24px;
  }

  .pc_customerServer_container_footer_header_handle img {
    width: 22px !important;
    height: 22px !important;
  }

  .pc_customerServer_container_footer_input > div {
    height: 60px;
    max-height: 60px;
    font-size: 16px; /* 防止 iOS 缩放 */
    line-height: 20px;
  }

  .pc_customerServer_container_footer_input-textarea {
    font-size: 16px !important;
  }

  .pc_customerServer_container_footer_handle_send {
    width: 70px;
    height: 34px;
    font-size: 15px;
    margin-right: 0;
  }

  /* 隐藏版权链接 */
  .pc_customerServer_container_footer_copyright {
    display: none !important;
  }

  /* 商品展示适配 */
  .productMessage_container {
    padding: 8px;
    height: auto;
    flex-shrink: 0;
  }

  .productMessage_container_image img {
    width: 56px;
    height: 56px;
  }

  .productMessage_container_content_title {
    font-size: 13px;
  }

  .productMessage_container_content_priceOrHandle > div:nth-child(1) {
    font-size: 15px;
  }

  .productMessage_container_content_priceOrHandle > div:nth-child(2) {
    width: 56px;
    height: 22px;
    font-size: 11px;
    line-height: 22px;
  }

  .pt140 {
    padding-bottom: 100px !important;
  }

  /* 关闭按钮移动端 */
  .fixed {
    display: none;
  }

  /* 移除桌面滚动条样式在移动端的应用 */
  .advertisement::-webkit-scrollbar {
    width: 0;
  }
}
</style>
